import React, { useState } from 'react';
import { FolderOpenOutlined } from '@ant-design/icons';
import './index.scss';
import classNames from 'classnames';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Button, message, Modal, Table } from 'antd';

const CheckSolidifiedData = ({ vehicleName }: { vehicleName: string }) => {
  const fetchApi = new CollectMapApi();
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [canceledTask, setCanceledTask] = useState<string[]>([]);
  const [tableList, setTableList] = useState<any[]>([]);
  const [cancelBtnLoading, setCancelBtnLoading] = useState<{
    taskId: string | null;
    loading: boolean;
  }>({
    taskId: null,
    loading: false,
  });
  const columns: any[] = [
    {
      title: '任务ID',
      width: 15,
      dataIndex: 'taskId',
      align: 'center',
      render: (value: any, record: any, index: number) => value || '-',
    },
    {
      title: '描述',
      width: 130,
      dataIndex: 'description',
      align: 'center',
      render: (value: any, record: any, index: number) => value || '-',
    },
    {
      title: '生成时间',
      width: 40,
      dataIndex: 'createTime',
      align: 'center',
      render: (value: any, record: any, index: number) => value || '-',
    },
    {
      title: '操作',
      width: 20,
      dataIndex: 'operate',
      align: 'center',
      render: (value: any, record: any, index: number) => {
        return (
          <Button
            type="link"
            className={classNames('cancel-solidify', {
              clicked: canceledTask.includes(record.taskId),
            })}
            loading={
              record.taskId === cancelBtnLoading.taskId
                ? cancelBtnLoading.loading
                : false
            }
            onClick={() => {
              setCancelBtnLoading({
                taskId: record.taskId,
                loading: true,
              });
              fetchApi
                .cancelSolidifiedTask({ taskId: record.taskId })
                .then((res) => {
                  if (res.code === HttpStatusCode.Success) {
                    message.success('取消固化成功');
                    setCanceledTask(canceledTask.concat([record.taskId]));
                  } else {
                    message.error(res.message);
                  }
                })
                .finally(() => {
                  checkData();
                });
              setCancelBtnLoading({
                taskId: null,
                loading: false,
              });
            }}
          >
            取消固化
          </Button>
        );
      },
    },
  ];
  const checkData = async () => {
    const res = await fetchApi.checkSolidifiedData({ vehicleName });
    if (res.code === HttpStatusCode.Success) {
      setTableList(res.data);
      setModalShow(true);
    }
  };

  return (
    <>
      <li
        className={classNames('btn-item', {
          'check-solidified-data': true,
        })}
        onClick={() => checkData()}
      >
        <FolderOpenOutlined />
        <i>查看固化数据</i>
      </li>
      {modalShow && (
        <Modal
          title="固化数据信息"
          width={1800}
          open={modalShow}
          footer={[
            <Button
              key="back"
              onClick={() => {
                setTableList([]);
                setCanceledTask([]);
                setModalShow(false);
              }}
            >
              关闭
            </Button>,
          ]}
          onCancel={() => {
            setTableList([]);
            setCanceledTask([]);
            setModalShow(false);
          }}
        >
          <Table
            rowKey={'taskId'}
            columns={columns}
            scroll={{ y: 500 }}
            dataSource={tableList}
            pagination={false}
          />
        </Modal>
      )}
    </>
  );
};

export default React.memo(CheckSolidifiedData);
